export default __webpack_public_path__ + "static/media/banner4.881d7dd1.webp";